export function authorsListSelector(state) {
  const ids = authorsListStateSelector(state).items
  return ids.map((id) => state.entities.authors[id])
}

export function authorsListStateSelector(state) {
  return state.local.authors.list
}
